import React from "react";
import { useIntl } from "react-intl";

export default function Comments({ comment }) {
  const intl = useIntl();
  return (
    <p className="comment answerArea mt-2">
      <span className="me-1">{intl.formatMessage({ id: "comment" })}:</span>
      {comment}
    </p>
  );
}
